import { render, staticRenderFns } from "./Ameba.vue?vue&type=template&id=506eb9ee&scoped=true&"
import script from "./Ameba.vue?vue&type=script&lang=js&"
export * from "./Ameba.vue?vue&type=script&lang=js&"
import style0 from "./Ameba.vue?vue&type=style&index=0&id=506eb9ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506eb9ee",
  null
  
)

export default component.exports